import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import SelectCustomer from '../layout/SelectCustomer';
import Helper from '../../../helper/Helper';
import { useTranslation } from 'react-i18next';
import ProductCal from '../layout/ProductCal';
import { CREDIT_NOTE_DETAILS, GET_CREDITNOTE_NUMBER, GET_INVOICES, SAVE_CREDIT_NOTE, UPDATE_CREDIT_NOTE } from '../../../data/url';
import Alert from '../../../feature/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import httpClient from '../../../http/HttpRequest';
import Select from 'react-select';

export default function NewCreditNote() {

     const [noteDetails, setNoteDetails] = useState({ prefix: '', number: '', date: Helper.getToday(), invoice_number: null, invoice_date: '', reason: '' });

     const [state_id, setStateId] = useState('');
     const [customerId, setCustomerId] = useState('');
     const [customer, setCustomer] = useState({});
     const [errors, setErrors] = useState({});
     const [invoiceOptions, setInvoiceOptions] = useState([]);
     const [invoices, setInvoices] = useState([]);
     const [loading, setLoading] = useState(false);
     const [products, setProducts] = useState([]);
     const [creditNote, setCreditNote] = useState([]);
     const [customerDetails, setCustomerDetails] = useState({});
     const [notes, setNotes] = useState({});
     const [updatedProducts, setUpdatedProducts] = useState([]);

     const { id } = useParams();

     const navigate = useNavigate();

     const { t } = useTranslation();

     const remitCustomer = (data) => {
          setCustomerId(data.customer_id);
          setStateId(data.state_id);
          setCustomer(data.customer);
     }

     useEffect(() => {
          if (id) {
               getcreditNoteDetails();
          } else {
               getCreditNoteNumber();
          }
          getInvoices();
     }, [id])

     useEffect(() => {
          setNotes({ terms_conditions: creditNote.terms_conditions, private_notes: creditNote.private_notes });
          setNoteDetails({ prefix: creditNote.prefix, number: creditNote.number, date: creditNote.date, invoice_number: null, invoice_date: creditNote.invoice_date, reason: creditNote.reason })
     }, [customerDetails, creditNote,id]);

     useEffect(() => {
          if (products.length > 0) {
               const data = [];
               products.map((row, index) => {
                    data.push(
                         {
                              selectedProduct: { label: row.product_name, value: row.product_id },
                              desc: row.description,
                              sac: row.sac,
                              selectedUnit: { label: row.unit_name, value: row.unit_id },
                              quantity: row.quantity,
                              price: row.price,
                              discount: row.discount,
                              discountType: row.discountType,
                              tax: row.tax,
                              total: row.net_amount,
                              stock: row.stock,
                              taxableAmount: row.taxable_amount,
                              discountAmount: row.discount_amount,
                              taxAmount: row.tax_amount
                         }
                    )
               })
               setUpdatedProducts(data);
          }

     }, [products]);

     useEffect(() => {
          if (invoiceOptions.length !== 0){
               const i = invoiceOptions.find(element => element.value == creditNote.invoice_id);   
               const order = { ...noteDetails };
               order['invoice_number'] = i;
               setNoteDetails(order);                   
          }
     }, [invoiceOptions, creditNote])

     const getcreditNoteDetails = async (e) => {
          const res = await httpClient.post(CREDIT_NOTE_DETAILS, { credit_note_id: id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setCustomerId(result.data.credit_note.customer_id);
                    setCreditNote(result.data.credit_note);
                    setProducts(result.data.details);
                    setCustomerDetails(result.data.customer);
               }
          }
     }

     const getInvoices = async (input = '') => {
          setLoading(true);
          let payload = { string: input }
          const res = await httpClient.sendRequest(GET_INVOICES, payload);
          setLoading(false);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    let option = [];
                    setInvoices(data);
                    data.forEach(element => {
                         option.push({ label: `${element.prefix} ${element.invoice_number}`, value: element.invoice_id });
                    });
                    setInvoiceOptions(option);
               }
          }
     }

     const getCreditNoteNumber = async (e) => {
          const res = await httpClient.post(GET_CREDITNOTE_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setNoteDetails(prevOrderDetails => ({
                         ...prevOrderDetails,
                         prefix: result.prefix || '',
                         number: result.number || ''
                    }));
               }
          }
     }

     const onSelectChange = (inputValue, { action }) => {
          if (action === 'input-change') {
               getInvoices(inputValue);
          }
     };

     const handleInputChange = (fieldName, event) => {
          let value = '';
          const order = { ...noteDetails };
          if (typeof event === 'object' && !('target' in event)) {
               value = event;
               if (fieldName === 'invoice_number') {
                    let invoice_date = findInvoice(event.value);
                    if (invoice_date) {
                         order['invoice_date'] = invoice_date;
                    }
               }
          } else if (typeof event === 'object' && 'target' in event) {
               value = event.target.value;
          }

          order[fieldName] = value;
          setNoteDetails(order);
     };

     const findInvoice = (invoice_id) => {
          const invoice = invoices.find(element => element.invoice_id === invoice_id);
          if (invoice) {
               return invoice.invoice_date;
          } else {
               return false;
          }
     };

     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = { ...noteDetails };
                    p['invoice_id'] = p.invoice_number.value;
                    delete p['invoice_number'];
                    p['customer_id'] = customerId;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    if (id) {
                         p['credit_note_id'] = id;  
                         updateOrder(p); 
                    } else{
                         saveOrder(p);
                    }                    
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(SAVE_CREDIT_NOTE, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    navigate('/root/credit-note');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const updateOrder = async (post) => {
          const res = await httpClient.post(UPDATE_CREDIT_NOTE, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    navigate('/root/credit-note');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (customerId === '') {
               Alert.error('Select Customer');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title={id ? "edit_credit_note" : "new_credit_note"} subTitle="credit_notes" subTitleLink="root/credit-note" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectCustomer remitCustomer={remitCustomer} customerId={customerId} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-3 '>
                                        <label htmlFor='prefix'>{t('number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={noteDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={noteDetails.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='date'>{t('date')}</label>
                                        <input id='date' value={noteDetails.date} type='date' name='date' className='form-control form-control-sm' onChange={(e) => handleInputChange('date', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='invoice_number'>{t('invoice_number')}</label>
                                        <Select
                                             id='invoice_number'
                                             value={noteDetails.invoice_number}
                                             options={invoiceOptions}
                                             isSearchable={true}
                                             placeholder="Select"
                                             onChange={(e) => handleInputChange('invoice_number', e)}
                                             onInputChange={onSelectChange}
                                             isLoading={loading}
                                        />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='invoice_date'>{t('invoice_date')}</label>
                                        <input id='invoice_date' value={noteDetails.invoice_date} type='date' name='invoice_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_date', e)} />
                                   </div>
                                   <div className='col-md-6 mt-2'>
                                        <label htmlFor='reason'>{t('reason')}</label>
                                        <input id='reason' value={noteDetails.reason} type='text' name='reason' className='form-control form-control-sm' onChange={(e) => handleInputChange('reason', e)} />
                                   </div>
                              </div>
                              <ProductCal title="credit_note" onSubmit={handelSubmit} customer={customer} products={updatedProducts} notes={notes} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
